import React from 'react';
import { InvoiceTemplateProps } from './types';
import Header from './primitives/Header';
import InvoiceTitle from './primitives/Title';
import PatientInfo from './primitives/PatientInfo';
import InvoiceDetails from './primitives/InvoiceDetails';
import ItemsTable from './primitives/ItemsTable';
import Totals from './primitives/Totals';
import Footer from './primitives/Footer';

export default function Template8_WithWatermark({ invoice, hospital }: InvoiceTemplateProps) {
  const getWatermarkText = () => {
    if (invoice.status === 'paid') return 'PAID';
    if (invoice.status === 'overdue') return 'OVERDUE';
    if (invoice.status === 'partial') return 'PARTIAL PAYMENT';
    return 'DRAFT';
  };

  const getWatermarkColor = () => {
    if (invoice.status === 'paid') return 'text-green-200';
    if (invoice.status === 'overdue') return 'text-red-200';
    if (invoice.status === 'partial') return 'text-yellow-200';
    return 'text-gray-200';
  };

  return (
    <div 
      className="invoice-root bg-white p-8 max-w-[210mm] mx-auto relative" 
      style={{ 
        minHeight: '297mm',
        fontFamily: 'Inter, "Noto Sans Bengali", Arial, sans-serif',
      }}
    >
      {/* Watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <div className={`text-9xl font-bold ${getWatermarkColor()} transform rotate-[-45deg] opacity-10 select-none`}>
          {getWatermarkText()}
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Header hospital={hospital} showLogo={true} variant="centered" />
        <InvoiceTitle />

        <div className="grid grid-cols-2 gap-8 mb-3">
          <PatientInfo invoice={invoice} layout="column" />
          <InvoiceDetails invoice={invoice} />
        </div>
        
        <ItemsTable items={invoice.items} variant="standard" headerColor="bg-primary-600" />
        
        <Totals invoice={invoice} layout="standard" showPaymentInfo={true} />
        
        {invoice.payment_method && (
          <div className="mb-6 p-4 bg-green-50 border-l-4 border-green-600">
            <p className="text-sm">
              <span className="font-semibold">Payment Method:</span> {invoice.payment_method}
            </p>
            {invoice.status === 'paid' && (
              <p className="text-sm text-green-700 mt-1">
                ✓ Payment received on {new Date(invoice.issue_date).toLocaleDateString()}
              </p>
            )}
          </div>
        )}
        
        <Footer variant="signature" notes={invoice.notes} />
        
        <div className="mt-8 pt-4 border-t text-center text-xs text-gray-500">
          <p>This invoice is subject to our standard terms and conditions.</p>
          <p className="mt-1">For queries, please contact: {hospital.phone} | {hospital.email}</p>
        </div>
      </div>
    </div>
  );
}
